import { match } from 'ts-pattern';
import { Pill, type PillProps, type PillVariant } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import { IxcOrdersV1Side } from '@interxfi/types/generated/api';

interface OrderSidePillProps extends Omit<PillProps, 'children' | 'variant'> {
  side: IxcOrdersV1Side | undefined;
}

export function OrderSidePill({ isPending, loadingCharacters = 4, side, ...props }: OrderSidePillProps) {
  return (
    <Pill
      isPending={!side || isPending}
      loadingCharacters={loadingCharacters}
      {...props}
      variant={match(side)
        .returnType<PillVariant>()
        .with(IxcOrdersV1Side.Buy, () => 'green')
        .with(IxcOrdersV1Side.Sell, () => 'danger')
        .otherwise(() => 'neutral')}
    >
      <TranslatedText defaultValue={side} i18nKey={{ namespace: 'ixcOrdersV1', enumName: 'IxcOrdersV1Side', value: side }} />
    </Pill>
  );
}
